import { render, staticRenderFns } from "./DatenschutzView.vue?vue&type=template&id=ed160ba8"
import script from "./DatenschutzView.vue?vue&type=script&lang=js"
export * from "./DatenschutzView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports